module.exports = __webpack_public_path__ + "img/header_logo.cc29ba62.png";